export const isStatelessResource = url => {
  if (!url) {
    return false
  }

  return /\/api\//.test(url)
}
